module.exports = ".custom-pay-btn {\n  background: #fc8e7f;\n  border: none;\n  border-radius: 5px;\n}"